import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { pedidoSetoresGep } from '../../../../home/pedido/gep/setor-gep/pedido-setor-gep';

@Component({
  selector: 'sgt-novo-pedido-setor-gep-multiselect',
  templateUrl: './novo-pedido-setor-gep-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoPedidoSetorGepMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoPedidoSetorGepMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() setoresGep: number[];
  @Output() setoresGepChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione os setores GEP',
    plural: 'Setores GEP',
    singular: 'Setor GEP',
    searchEmptyResultMessage: 'Nenhum setor encontrado',
    showFooter: false
  };

  options: IOption[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = pedidoSetoresGep.map((setorGep) => ({
      id: setorGep.id,
      label: setorGep.nome
    }));
  }

  onSearch() {
    this.setoresGepChange.emit(this.setoresGep);
  }

  onChangeSetoresGep() {
    this.emitChange(this.setoresGep);
    this.setoresGepChange.emit(this.setoresGep);
  }

  protected updateValue(newValue: number[] | null): void {
    this.setoresGep = newValue ?? null;
  }
}
